<script setup>
import { register } from 'swiper/element/bundle';
import { onMounted, ref } from 'vue';

const props = defineProps(['applicants'])

const applicants = ref(JSON.parse(props.applicants));

const applicantSlider = ref();

const applicantSliderParams = {
  loop: true,
  speed: 500,
  spaceBetween: 30,
  navigation: true,
  grabCursor: true,

  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    640: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3.5,
    },
    1280: {
      slidesPerView: 5.5,
    },
  },
};

onMounted(() => {
  register();
  Object.assign(applicantSlider.value, applicantSliderParams);
  applicantSlider.value.initialize();
})
</script>

<template>
  <swiper-container class="tw-mx-auto sm:tw-pt-0 tw-px-8 md:tw-pr-0 tw-grid" init="false" ref="applicantSlider">


    <swiper-slide v-for="(applicant, index) in applicants " :key="index" class="tw-h-full">
      <a :href="'/profile/' + applicant.id" class="!tw-no-underline tw-group">
        <article
          class="tw-h-full tw-relative isolate tw-flex tw-flex-col tw-justify-end tw-overflow-hidden tw-rounded-2xl tw-px-8 tw-pb-8 tw-pt-70 tw-pt-48 lg:tw-pt-70">
          <img :src="applicant.avatar" alt=""
            class="tw-absolute tw-inset-0 -tw-z-10 tw-h-full tw-w-full tw-object-cover group-hover:tw-scale-110 tw-transition">
          <div class="tw-absolute tw-inset-0 tw--z-10 tw-bg-gradient-to-t tw-from-gray-900 via-gray-900/40">
          </div>

          <span v-if="applicant.new"
            class="tw-absolute tw-top-5 tw-right-5 tw-inline-flex tw-items-center tw-rounded-md tw-bg-primary-50 tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-text-primary-500 tw-ring-1 tw-ring-inset tw-ring-primary-600/20">Neu</span>

          <div
            class="tw-flex tw-flex-wrap tw-items-center tw-gap-y-1 tw-overflow-hidden tw-text-sm tw-leading-6 tw-text-gray-300">
            <div class="tw--mr-1 tw-flex tw-gap-x-4 tw-flex-col">
              <div class="tw-flex tw-gap-x-2.5 tw-text-white">
                <img :src="applicant.avatar" alt="" class="tw-h-6 tw-w-6 tw-flex-none tw-rounded-full bg-white/10">
                {{ applicant.name }}
              </div>
            </div>
          </div>

          <template v-if="applicant.jobRequestCount">
            <span class="tw-text-gray-300 tw-text-xs tw-mt-3">Interessiert an</span>
            <h3 class="tw-text-base tw-font-semibold tw-leading-6 tw-text-white tw-mb-0">
              {{ applicant.firstJobRequest }}
            </h3>
            <template v-if="applicant.jobRequestCount > 1">
              <span class="tw-text-white tw-text-xs">+ {{ applicant.jobRequestCount - 1 }} weitere</span>
            </template>
          </template>
        </article>
      </a>
    </swiper-slide>

  </swiper-container>
</template>
